import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LinkSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LinkSVG;
